export enum SuccessMessagesEnum {
  AddPhoneNumber = 'successfully added',
  DeletePhoneNumber = 'successfully removed',
}

export enum DesktopNotificationPermissionEnum {
  granted = 'granted',
  denied = 'denied',
  default = 'default',
}
